var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":("comp_id_" + (_vm.compProps.elementId))}},[_c(_vm.compName,{tag:"component",attrs:{"compProps":_vm.docContent,"compId":(_vm.compProps.elementId+'')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }